const SkeletonPage = () => {
  return (
    <div className="bg-gray-50 min-h-screen px-6 py-8 flex flex-col items-center">
      
      <div className="w-20 h-5 bg-gray-200 rounded mb-8 animate-pulse"></div>

      <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr] gap-8 w-full max-w-6xl">
        
        <div className="flex flex-col gap-5">
          
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col gap-3">
            <div className="h-3 w-3/5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-full bg-gray-200 rounded animate-pulse"></div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col gap-3">
            <div className="h-3 w-3/5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-full bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-1/2 bg-gray-200 rounded animate-pulse"></div>

            <div className="flex gap-3 mt-3">
              <div className="h-8 flex-1 bg-gray-200 rounded-md animate-pulse"></div>
              <div className="h-8 flex-1 bg-gray-200 rounded-md animate-pulse"></div>
              <div className="h-8 flex-1 bg-gray-200 rounded-md animate-pulse"></div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-5">
          <div className="bg-white rounded-xl p-6 shadow-sm flex flex-col gap-3">
            
            <div className="w-12 h-12 bg-gray-200 rounded-md animate-pulse mb-3"></div>

            <div className="h-3 w-3/5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-2/5 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-1/2 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-3 w-[90%] bg-gray-200 rounded animate-pulse"></div>

            <div className="flex gap-3 mt-3">
              <div className="h-8 flex-[3] bg-gray-200 rounded-md animate-pulse"></div>
              <div className="h-8 flex-1 bg-gray-200 rounded-md animate-pulse"></div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default SkeletonPage;
